<template>
  <v-bottom-navigation
    fixed
    scroll-target="#scroll-threshold-example"
    scroll-threshold="500"
    height="96"
  >
    <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
      <v-col cols="12">
        <v-btn
          block
          elevation="0"
          class="btn-fixed"
          style="background-color: #465166"
          @click="$emit('clickBtn')"
        >
          <span class="white--text">{{ btnName }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
export default {
  props: {
    btnName: String,
  },
};
</script>

<style></style>
